
import Vue from "vue";

import { Component, Prop, Watch } from "vue-property-decorator";
import { ActionMethod } from "vuex";
import { Getter, Action } from "vuex-class";

import Cupom from "@/components/core/Cupom.vue";
import PlanDialog from "@/components/common/PlanDialog/index.vue";
import { IsOfferWeek, NotShowIcon } from "@/utils/PlanRules";
import { showSkeelo } from "@/utils/Skeelo";
import { SelectedPlanType } from "@/types/PlansType";
import { CouponType } from "@/types/CouponTypes";
import { BlackFridayParamsType } from "@/types/FirebaseTypes";

@Component({
  name: "CardPlan",
  methods: { showSkeelo },
  components: {
    Cupom,
    PlanDialog,
  },
})
export default class CardPlan extends Vue {
  @Prop({ default: null }) readonly plan!: SelectedPlanType;
  @Prop({ default: true }) readonly opt!: boolean;
  @Prop({ default: 0 }) readonly instance!: number;
  @Prop({ default: null }) readonly path!: string;
  @Prop({ default: false }) readonly lock!: boolean;
  @Prop({ default: false }) readonly cupom!: boolean;
  @Prop({ default: true }) readonly editCupom!: boolean;
  @Prop({ default: false }) readonly open!: boolean;
  @Prop({ default: false }) readonly isCarousel!: boolean;
  @Getter blackFriday!: BlackFridayParamsType;
  @Action checkCupom!: ActionMethod;
  @Getter tiktok!: string[];
  @Getter skeeloCompositionId!: string[];
  @Getter coupon!: CouponType;
  @Getter coupons!: CouponType[];
  @Getter isMeli!: boolean;
  openDetail = false;
  off = "";
  showAlertMessage = false;
  internet = "";
  tag = "";
  price = "";
  discounts = "";
  valorBonus = "";
  id = "";
  paramBonus = false;
  cupomOff = false;
  info = false;
  cupomSelected = "";
  cupomType = "";
  freeFireCompositionName = process.env.VUE_APP_FREE_FIRE_COMPOSITION_NAME;

  @Watch("coupon")
  onceCoupon() {
    if (this.coupon) {
      this.onSuccessCupom(this.coupon);
    }
  }

  @Watch("coupons")
  onceCoupons() {
    const selectCoupon = this.coupons.find(
      (coupon) => coupon.planId === this.plan.id
    );
    if (selectCoupon) {
      this.off = (
        (this.plan.totalPrice.amount - selectCoupon.discounts[0].value.amount) /
        100
      )
        .toFixed(2)
        .toString();
    }
  }

  @Watch("plan")
  oncePlan() {
    if (this.plan.offerParameters.CUPOM_DESC) {
      this.cupomSelected = this.plan.offerParameters.CUPOM_DESC;
    }
  }

  isBlackFridayShow(id: string) {
    return this.blackFriday.plans.includes(id);
  }

  renderTextPlan(plan: string, bonus: string, price: number | string) {
    if (bonus !== "" && Number(bonus) > 0 && this.off) {
      return `${Number(plan) + Number(bonus)}GB | R$ ${
        this.off
      }  NO PRIMEIRO MÊS`;
    }
    return `${Number(plan) + Number(bonus)}GB | R$ ${price} NO PLANO`;
  }

  isOfferWeekShow(id: string) {
    return IsOfferWeek(id);
  }

  isShowIcon(id: string) {
    return NotShowIcon(id);
  }

  renderPlan(bonus: string | number, franchise: string | number) {
    return Number(bonus) + Number(franchise);
  }

  openInfo(plan: any): void {
    const win = window as any;
    if (this.info) {
      this.info = false;
      if (plan.id === "736df6a5-cb49-436c-bd5d-4255e2b007ba") {
        if (this.$gtm.enabled()) {
          win.dataLayer.push({
            event: "event",
            eventCategory: "claro-flex:home",
            eventAction: "clique:botao",
            eventLabel: "skeelo:16gb-mes-com-skeelo-padrao",
          });
        }
      }
      if (plan.id === "0b54bed4-1881-4d63-bf67-a88fbc3e04bc") {
        if (this.$gtm.enabled()) {
          win.dataLayer.push({
            event: "event",
            eventCategory: "claro-flex:home",
            eventAction: "clique:botao",
            eventLabel: "skeelo:10gb-mes-com-skeelo-padrao",
          });
        }
      }
      if (plan.id === "929d4daa-b0cb-4be9-9eba-10ba530c2535") {
        if (this.$gtm.enabled()) {
          win.dataLayer.push({
            event: "event",
            eventCategory: "claro-flex:home",
            eventAction: "clique:botao",
            eventLabel: "skeelo:08gb-mes-com-skeelo-light",
          });
        }
      }
    } else {
      this.info = true;
    }
  }

  inOpen(id: string) {
    this.$emit("openDropdown", id);
  }

  inOpenDetail() {
    this.openDetail = !this.openDetail;
  }

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  async onSuccessCupom({ discounts, code }: CouponType) {
    if (discounts) {
      this.cupomSelected = code;
      const vl = parseFloat(this.plan.totalPrice.amountFormatted);
      this.off = (vl - this.format(String(discounts[0].value.amount))).toFixed(
        2
      );
      this.discounts = this.format(String(discounts[0].value.amount));
    }
  }

  format(num: any) {
    let v = num.replace(/\D/g, "");
    v = Number(v) / 100;
    v = v.toFixed(2);
    return v;
  }

  getLabelName() {
    const self = this as any;
    return self.plan.tag;
  }

  openDetails(plan: any): void {
    const self = this as any;
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:botao",
        eventLabel: "mais-detalhes:".concat(plan.tag),
      });
    }
    const dataLayerPlans: any = [];
    dataLayerPlans.push({
      name: this.getLabelName(),
      id: self.plan.id,
      price: self.plan.totalPrice.amountFormatted,
      brand: "claro-movel",
      category: "plano/celular/flex",
      variant: "migracao",
    });

    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "productDetail",
        eventCategory: "claro-flex:enhanced-ecommerce",
        eventAction: "product-detail",
        noInteraction: "1",
        ecommerce: {
          detail: {
            products: dataLayerPlans,
          },
        },
      });
    }
    function onChangeTag(name: any) {
      if (self.$gtm.enabled()) {
        win.dataLayer.push({
          event: "event",
          eventCategory: `claro-flex:${name}`,
          eventAction: "clique:botao",
          eventLabel: `mais-detalhes:mais-detalhes-${plan.tag}`,
        });
      }
    }

    switch (this.path) {
      case "cadastro-dados":
        onChangeTag("cadastro-dados");
        break;
      case "cadastro-endereco":
        onChangeTag("cadastro-endereco");
        break;
      case "cadastro-telefone":
        onChangeTag("cadastro-telefone");
        break;
      case "cadastro-pagamento":
        onChangeTag("cadastro-pagamento");
        break;
      case "cadastro-sucesso":
        onChangeTag("cadastro-sucesso");
        break;
      default:
        break;
    }

    this.price = self.plan.totalPrice.amountFormatted.replace(".", ",");
    this.internet = `${
      Number(self.plan.offerParameters.FRANQUIA_PLANO) +
      Number(self.plan.offerParameters.BONUS_PLANO)
    } GB`;
    this.paramBonus = self.plan.paramBonus;
    this.valorBonus = self.plan.valorBonus;
    this.id = self.plan.id;
    this.showAlertMessage = true;
  }

  closeModal(): void {
    const win = window as any;

    const self = this as any;

    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:botao",
        eventLabel: "ok-entendi:".concat(self.plan.tag),
      });
    }

    this.showAlertMessage = false;
  }

  mounted() {
    if (this.coupon && !this.isCarousel) {
      this.onSuccessCupom(this.coupon);
    }
  }
}
